<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <router-link
        tag="button"
        :to="{ name: 'DocumentTypeCreate' }"
        class="mb-1 btn btn-sm btn-primary float-right">{{$t('buttons.create')}}</router-link>
    </template>
    <template #filtering>
      <div class="text-right">
        <b-button aria-controls="log_search_collapse" class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.log_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="log_search_collapse" class="mt-2">
          <DocumentTypeFiltering @getPage="getPage($event)"></DocumentTypeFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <span v-else-if="!isLoading && items.length < 1">{{ $t('views.documenttype.list.noDocuments') }}</span>
      <table v-else class="table table-sm table-responsive-md table-striped table-hover">
        <thead>
        <tr>
          <th>{{ $t('views.documenttype.list.title') }}</th>
          <th>{{ $t('views.documenttype.list.subtitle') }}</th>
          <th>{{ $t('views.documenttype.list.language') }}</th>
          <th>{{ $t('views.documenttype.list.version') }}</th>
          <th>{{ $t('views.documenttype.list.specialInfo') }}</th>
          <th>{{ $t('views.exsbdocument.form.allowedExtensions') }}</th>
          <th style="width: 5%" colspan="1" />
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in items"
          :key="item['@id']">
          <td>
            {{item.title}}
          </td>
          <td>
            {{ item.subtitle }}
          </td>
          <td>
            {{ item.language }}
          </td>
          <td>
            {{ item.version }}
          </td>
          <td>
            {{ item.specialInfo }}
          </td>
          <td>
            <span v-if="item.allowedExtensions">{{item.allowedExtensions}}</span>
            <span v-else>{{$t('views.exsbdocument.form.defaultExtensions')}}</span>
          </td>
          <td>
            <div class="btn-group">
              <router-link
                tag="button"
                :to="{name: 'DocumentTypeUpdate', params: { id: item['@id'] }}"
                class="float-right btn btn-link fa fa-edit fa-lg"
                v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="view">
        <pagination
          :view="view"
          @getPage="getPage($event)"
        ></pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import DocumentTypeFiltering from '@/components/Dashboard/Views/documenttype/components/DocumentTypeFiltering'

export default {
  components: {
    Loader,
    Pagination,
    DocumentTypeFiltering,
    BaseTableWrapper
  },

  computed: mapGetters({
    deletedItem: 'documenttype/del/deleted',
    error: 'documenttype/list/error',
    items: 'documenttype/list/items',
    isLoading: 'documenttype/list/isLoading',
    view: 'documenttype/list/view'
  }),

  // beforeCreate () {
  //   checkPagePermission('configuration', 'DocumentTypeList')
  // },

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'documenttype/list/default'
  })
}
</script>
